<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <a
                v-bind = "attrs"
                v-on   = "on"
                class  = "audit-menu"
            >
                <div
                    v-if="label"
                    class  = "fab-button"
                >
                    <div
                        class  = "fab-icon primary-border"
                    >
                        <v-icon size="22" color="primary">{{ icon }}</v-icon>
                    </div>
                    <div class="fab-label">
                        {{ label }}
                    </div>
                </div>

                <div
                    v-if="!label"
                    class  = "fab-button v-flex"
                >
                    <v-icon size="22" color="primary">{{ icon }}</v-icon>
                    <v-icon size="25" class="ml-n1" color="black">mdi-menu-down</v-icon>
                </div>
            </a>
        </template>

        <div class="white">
            <v-list class="white">
                <v-list-item
                    v-for = "(entry, index) in menu"
                    :key  = "index"
                    link
                    :style="entry.id ? null : 'min-height: 4px'"
                >
                    <v-divider v-if="!entry.id" />
                    <v-list-item-title
                        v-if   = "entry.id"
                        @click = "onEntry(entry)"
                    >
                        <div v-if="columns === 1" class="v-flex">
                            <div v-if="entry.icon"  style="margin-top: -3px; padding-right: 6px;">
                                <v-icon size="22" color="primary">{{ entry.icon }}</v-icon>
                            </div>
                            <div>
                                {{ entry.name }}
                            </div>
                        </div>
                        <div v-if="columns > 1" class="v-flex">
                            <div>
                                {{ entry.column[0] }}
                            </div>
                            <div class="pl-2">
                                {{ entry.column[1] ? entry.column[1] : '---'}}
                            </div>
                        </div>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </div>
    </v-menu>
</template>

<script>
export default {
    name: "CFabMenu",

    props: {
        label: {

        },

        icon: {

        },

        menu: {

        },

        columns: {
            required: false,
            default : function () {
                return 1;
            }
        }
    },

    methods: {
        onEntry (entry) {
            this.$emit("entry", entry);
        }
    }
}
</script>

<style lang="scss" scoped>


.fab-button  {
    width: 40px;
    min-width: 40px;
    z-index: 100;
}

.fab-button-small  {
    width: 60px;
    min-width: 60px;
    z-index: 100;
    position: relative;
}

.fab-icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    border-radius: 20px;
    text-align: center;
    padding-top: 6px;
    margin-left: auto;
    margin-right: auto;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    background-color: white;
}

.fab-label {
    margin-top: 4px;
    font-size: 11px;
    text-align: center;
}

</style>
